import { useState } from 'react'

import { formatNumberAsThousands } from '../../../utils/priceHelpers'
import styles from './ComissionSlider.module.scss'

const ComissionSlider = ({ totalCommisson, min = 5, max = 70, step = 5 }) => {
  const [val, setVal] = useState(5)

  return (
    <div className={styles.container}>
      <div className={styles.controlHalf}>
        <div className={styles.inputBox}>
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={val}
            onChange={e => setVal(e.target.value)}
          />
        </div>
        <div className={styles.ifBox}>
          If <strong>%{val}</strong>
          <p>of the OTA bookings were converted to direct bookings</p>
        </div>
      </div>
      <div className={styles.resultHalf}>
        <p className={styles.regularP}>your hotel get to earn</p>
        <strong>${formatNumberAsThousands((totalCommisson * val) / 100)}</strong>
        <p className={styles.smallerP}>additional revenue</p>
      </div>
    </div>
  )
}

export default ComissionSlider
